import { render, staticRenderFns } from "./groupBooks.vue?vue&type=template&id=3c32c44e&"
import script from "./groupBooks.vue?vue&type=script&lang=js&"
export * from "./groupBooks.vue?vue&type=script&lang=js&"
import style0 from "./groupBooks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports